import client from '@plone/volto/start-client';
import './iconsConfig';
client();

if (module.hot) {
  module.hot.accept();
}
